<template>
  <v-card class="mt-6">
    <v-card-title>
      Cadastro do Hotel
    </v-card-title>
    <v-card-text>
      <v-row no-gutters>
        <v-col class="mr-4">
          <v-text-field
            :value="config.name"
            outlined
            label="Nome"
            @input="updateField('name', $event)"
          />
        </v-col>
        <v-col>
          <v-text-field
            v-mask="'(##)####-####'"
            :value="config.phone"
            outlined
            label="Telefone"
            @input="updateField('phone', $event)"
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <v-text-field
            :value="config.address"
            outlined
            label="Endereço"
            @input="updateField('address', $event)"
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="mr-4">
          <v-text-field
            :value="config.site"
            outlined
            label="Site"
            @input="updateField('site', $event)"
          />
        </v-col>
        <v-col>
          <v-text-field
            :value="config.email"
            outlined
            label="Email"
            @input="updateField('email', $event)"
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="pr-2 col-6">
          <v-text-field
            :value="config.legal_name"
            outlined
            label="Razão Social"
            @input="updateField('legal_name', $event)"
          />
        </v-col>
        <v-col class="pr-2 col-3">
          <v-text-field
            v-mask="'##.###.###/####-##'"
            :value="config.cnpj"
            outlined
            label="CNPJ"
            @input="updateField('cnpj', $event)"
          />
        </v-col>
        <v-col class="col-3">
          <v-text-field
            :value="config.im"
            outlined
            label="Inscrição Municipal"
            @input="updateField('im', $event)"
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <v-file-input
            outlined
            accept="image/*"
            label="Logo principal"
            @change="$emit('logo-change', $event)"
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <v-file-input
            outlined
            accept="image/*"
            label="Logo relatórios"
            @change="$emit('logo-report-change', $event)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'HotelInfo',
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit('update', { [field]: value })
    },
  },
}
</script>
